import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import API from 'services/API';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { getErrorMessage } from 'UI/utils';

const ACTION_BY_SEVERITY = {
  success: 'Updated',
  error: 'Updating'
};

const buildEntityStatusAlert = ({ severity, processType, body }) => ({
  severity,
  title: strings.formatString(strings.sendoutsV2.alerts.submitMessages[severity].title, {
    processType,
    action: ACTION_BY_SEVERITY[severity]
  }),
  autoHideDuration: 5000,
  ...(body ? { body } : {})
});

export const updateEntityStatus = async ({ id, payload, processType }) => {
  try {
    const endpoint = `${Endpoints.Sendouts}/${id}`;
    const response = await API.patch(endpoint, payload);

    if (response.status !== HTTPStatusCodes.Ok) {
      return {
        success: false,
        response,
        alert: buildEntityStatusAlert({
          severity: 'error',
          processType,
          body: `Unexpected response status: ${response.status}`
        })
      };
    }

    return {
      success: true,
      response,
      alert: buildEntityStatusAlert({ severity: 'success', processType })
    };
  } catch (error) {
    return {
      success: false,
      error,
      alert: buildEntityStatusAlert({
        severity: 'error',
        processType,
        body: getErrorMessage(error, error?.message ?? 'Something went wrong')
      })
    };
  }
};
